import { Component } from "preact";
import { connect } from "react-redux";

import { getContent, changeLocale } from "../state/actions/contentActions.js";

const CMSComponent = (dataId, WrappedComponent, height) => {
  class HOC extends Component {
    componentDidMount() {
      if (dataId) {
        const { getContent, content } = this.props;
        if (!content.data[dataId]) {
          getContent(dataId, content.locale);
        }
      }
    }

    componentDidUpdate(prevProps) {
      const { getContent, content } = this.props;
      if (dataId) {
        if (content.locale !== prevProps.content.locale) {
          getContent(dataId, content.locale);
        }
      }
    }

    render() {
      const { changeLocale, content } = this.props;
      const contentData = dataId ? content.data[dataId] : "";
      const locale = content.locale;
      const localeData = content.localeData;
      const loading =
        dataId && content.data[dataId] ? content.data[dataId].loading : true;
      const ticketURL = localeData.ticketURL
        ? localeData.ticketURL
        : "https://events.humanitix.com.au/";

      if (!dataId || !loading) {
        return (
          <WrappedComponent
            {...this.props}
            contentData={contentData}
            locale={locale}
            localeData={localeData}
            ticketURL={ticketURL}
            changeLocale={changeLocale}
          />
        );
      }

      return (
        <WrappedComponent
          {...this.props}
          contentData={{}}
          locale={"au"}
          localeData={{}}
          ticketURL={ticketURL}
          changeLocale={{}}
        />
      );
    }
  }

  return connect(
    (state, ownProps) => ({
      content: state.content
    }),
    { getContent, changeLocale }
  )(HOC);
};

export default CMSComponent;
